import { EntityName, Page } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Heading, useTableProps, Flex } from '@blockanalitica/ui';
import DSRDepositorsChart from './DSRDepositorsChart';
import DSRDepositorsTable from './DSRDepositorsTable';
import TextSeatchFilter from '@/components/TextSearchFilter/TextSearchFilter';

export default function DSRDespositorsPage() {
  const { pagination, sorting, filters } = useTableProps({
    filtersDebounceTime: 250,
    pageSize: 10,
    initialSorting: '-balance',
    initialFilters: {
      textSearch: ''
    }
  });
  return (
    <Page
      title={
        <EntityName
          symbol1={
            <CryptoIcon
              name={'DAI'}
              address={tokensMapping('DAI').address}
              size="4"
            />
          }>
          <Heading size="1">DAI Savings Rate Suppliers</Heading>
        </EntityName>
      }>
      <DSRDepositorsChart />
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSeatchFilter
          filters={filters}
          placeholder="Search by wallet address"
        />
      </Flex>
      <DSRDepositorsTable
        pagination={pagination}
        sorting={sorting}
        search={filters.filtersApplied['textSearch']}
      />
    </Page>
  );
}
